module.exports = __webpack_public_path__ + "img/one_eschema.34dea1c2.png";